import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import EmailTypeDialog from '@/views/settings/emailTemplates/email-type-manager/emailTypeDialog/EmailTypeDialog.vue';

import { mapState } from "vuex";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    EmailTypeDialog
  },
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    templateType: { name: '' },
    emailTemplatesTypes: Object.values(DefaultEmailTemplateType).map((x) => { return { name: x, isDefault: true } }),
    facilityEmailTemplateTypeList: [],
    headers: [
      {
        text: 'GeneralTranslations.Name',
        align: "",
        sortable: false,
        value: "name"
      }
    ],
  }),
  computed: {
    ...mapState({
      facilityEmailTemplateTypes: state => (state as any).facilityModule.facilityEmailTemplateTypes,
      facilityMailingLists: state => (state as any).facilityModule.facilityMailingLists
    })
  },
  created() {

    this.headers[0].text = this.$i18n.messages[this.$i18n.locale][this.headers[0].text]
    this.$store.dispatch("getFacilityEmailTemplateTypes");
    this.$store.dispatch("getFacilityMailingLists");
  },
  watch: {
    facilityEmailTemplateTypes(types) {
      this.facilityEmailTemplateTypeList = this.emailTemplatesTypes.concat(types)
    }
  },
  methods: {
    itemRowBackground(item) {
      return item.isDefault ? 'defaultType' : ''
    },
    addNewClick() {
      this.templateType = {
        id: null,
        name:'',
        mailingListIds: []
      }
      this.dialog = true;
    },
    handleClickEmailType(item): void {
      if (item.isDefault) return;

      this.templateType = { ...item }
      this.dialog = true;
    },

  }
};
